import { Heading, Box, Paragraph } from 'grommet'
import styled, { css } from 'styled-components'

import { Hexagon } from '../styles'

import { NormalizedWrapper } from '@theme'

const MOBILE_WIDTH = 294
const MARGIN_TOP = 30

export const Wrapper = styled(NormalizedWrapper)`
  position: relative;

  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.xl5}px;

    ${theme.below.laptop`
      padding: 0 ${theme.newSpaces.sm}px;
    `}

    ${theme.below.mobileXL`
      margin-top: ${theme.newSpaces.xl2}px;
      padding: 0 ${theme.newSpaces.lg}px;
    `}
  `}
`

export const Cards = styled(Box)`
  flex-direction: row;
  flex-wrap: no-wrap;
  justify-content: space-between;
  width: 100%;

  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.xl5}px;
    ${theme.below.laptop`
      flex-wrap: wrap;
    `}

    ${theme.below.desktopS`
      justify-content: space-around;
    `}

    ${theme.below.tablet`
      margin-top: ${theme.newSpaces.sm}px;
    `}

    ${theme.below.tabletS`
      justify-content: center;
    `}
  `}
`

export const CardTitle = styled(Heading)`
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-align: center;
  text-transform: uppercase;

  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'large')}

    background-image: ${theme.newColors.gradientGreen};

    ${theme.below.tabletS`
      margin: 0 auto;
    `}
  `}
`

export const CardSubtitle = styled(Paragraph)`
  margin-top: ${MARGIN_TOP}px;
  text-align: center;
  text-transform: uppercase;
  white-space: pre-wrap;

  ${({ theme }) => css`
    color: ${theme.newColors.primary};
    font-size: 30px;
    font-weight: 700;
    line-height: 38px;

    ${theme.below.tabletS`
      text-align: center;
    `}

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'title', 'blog')}

      margin-top: ${theme.newSpaces.xs2}px;
    `}
  `}
`

export const Card = styled(Box)`
  align-items: center;
  flex-direction: column;
  margin-top: ${MARGIN_TOP}px;
  text-align: center;

  &:first-child {
    ${CardSubtitle} {
      width: 307px;
    }
  }

  &:nth-child(2) {
    width: 330px;
    ${CardSubtitle} {
      width: 330px;
    }
  }

  &:nth-child(3) {
    ${CardSubtitle} {
      width: 268px;
    }
  }

  ${({ theme }) => css`
    ${theme.below.tablet`
      margin-bottom: ${theme.newSpaces.xs}px;
    `}

    ${theme.below.mobileXL`
      &:nth-child(n) {
        width: ${MOBILE_WIDTH}px;
          ${CardTitle} {
            width: ${MOBILE_WIDTH}px;
          }
          ${CardSubtitle} {
            width: ${MOBILE_WIDTH}px;
          }
        }
    `}
  `}
`

export const GrayHexagon = styled(Hexagon)`
  left: -30%;
  top: 52%;
`
